module.exports = __webpack_public_path__ + "img/uk.92cf9c8f.png";